<template>
  <div class="mapReminder">
    <i
      class="iconfont icon-guanbi2"
      style="color: red"
      @click="closeReminder"
    ></i>
    <div v-if="info" class="reminderDetail">
      <img :src="itemInfo.pictureUrl" alt="" />
      <div class="reminderDetail_text">
        <div class="text-ellipsis">{{ itemInfo.deviceName }}</div>
        <div>
          {{
            moment(parseInt(itemInfo.alarmTime)).format("YYYY-MM-DD HH:mm:ss")
          }}
        </div>
        <!-- <h-car-plate class="plateNo" :type="itemInfo.bizJson.plate_color">
          {{
            itemInfo.bizJson.plate_no == ""
              ? "暂无车牌"
              : itemInfo.bizJson.plate_no
          }}
        </h-car-plate> -->
        <!-- <h-button type="primary" @click="openDetail">查看警告</h-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { computed, defineComponent, reactive, toRefs, watchEffect } from "vue";

export default defineComponent({
  name: "mapReminder",
  components: {},
  props: {
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, context) {
    const data = reactive({
      info: null,
    });
    const refData = toRefs(data);

    watchEffect(() => {
      data.info = props.itemInfo;
      console.log(data.info);
    });
    const closeReminder = () => {
      context.emit("close");
    };
    const openDetail = () => {
      context.emit("openDetail", props.itemInfo);
    };

    return {
      ...refData,
      closeReminder,
      openDetail,
      moment,
    };
  },
});
</script>
<style lang="scss" scoped>
.mapReminder {
  font-size: 14px;
  position: relative;
  @include flex-col-c-c;
  i {
    position: absolute;
    right: 2px;
    top: 2px;
  }
  img {
    width: 90%;
    height: 60%;
    margin: 8px auto;
  }
  .reminderName {
    margin: auto;
  }
  .reminderDetail {
    width: 100%;
    @include flex-col-c-c;
    .reminderDetail_text {
      @include flex-col-sb-c;
    }
  }
  .reminderDetail ::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 10px solid;
    border-color: transparent;
    border-top-color: rgba(8, 13, 38, 0.8);
    top: 100%;
    left: 50%;
    margin-left: -10px;
  }
}
</style>
